import { createContext, useContext, useState } from "react";

const initialContext = {
  selectedCategory: "All Categories",
  setCategory: () => {},
};

const ShopNavContext = createContext(initialContext);

export const ShopNavProvider = ({ children }) => {
  const [category, setCategory] = useState("All Categories");
  const [renderSprite, setRenderSprite] = useState(true);

  return (
    <ShopNavContext.Provider
      value={{
        renderSprite,
        selectedCategory: category,
        setCategory: (cat) => {
          setCategory(cat);
          setRenderSprite(!renderSprite);
        },
      }}
    >
      {children}
    </ShopNavContext.Provider>
  );
};

const useShopNav = () => {
  return useContext(ShopNavContext);
};

export default useShopNav;
